/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Import_Parse_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't read the CSV file. {error}" |
*
* @param {Team_Manager_Import_Parse_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_parse_failed = /** @type {((inputs: Team_Manager_Import_Parse_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Parse_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de lire le fichier CSV. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die CSV-Datei konnte nicht gelesen werden. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile leggere il file CSV. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось прочитать CSV-файл. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo leer el archivo CSV. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法读取 CSV 文件。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`CSV ファイルを読み込めませんでした。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`CSV फ़ाइल पढ़ी नहीं जा सकी। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível ler o ficheiro CSV. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Couldn't read the CSV file. ${i?.error}`)
});